import breadcrumbs from "@/views/modules/UserRoles/MenuList.vue";
import lang from "@/views/modules/UserRoles/language/en";
import loader from "@/views/shared/loading/Loading.vue";


export default {
    name: "new-user-role",
    components: {
        breadcrumbs,
        loader,
    },
    data() {
        return {
            showDropdown: null,
            field_id: null,
            loading: false,
            modules: [],
            moduleOptions: [],
            action_data: [{
                'access': {},
                'delete': {},
                'export': {},
                'list': {},
                'edit': {},
                'view': {},
            }],
            availableOptions: [{
                'access': { 'Owner': 'Owner', 'Enabled': 'Enabled', 'Not Set': 'Not Set', 'Disabled': 'Disabled' },
                'delete': { 'Owner': 'Owner', 'Enabled': 'Enabled', 'Not Set': 'Not Set', 'Disabled': 'Disabled' },
                'export': { 'Owner': 'Owner', 'Enabled': 'Enabled', 'Not Set': 'Not Set', 'Disabled': 'Disabled' },
                'list': { 'Owner': 'Owner', 'Enabled': 'Enabled', 'Not Set': 'Not Set', 'Disabled': 'Disabled' },
                'edit': { 'Owner': 'Owner', 'Enabled': 'Enabled', 'Not Set': 'Not Set', 'Disabled': 'Disabled' },
                'view': { 'Owner': 'Owner', 'Enabled': 'Enabled', 'Not Set': 'Not Set', 'Disabled': 'Disabled' },
            }],
            userRole: {
            },
            lang: [],
            parentCompnent: null,
            record: null,
            showpassfiled: true,
            dom_array: [],
        }
    },
    watch: {
        modules: 'updateModuleOptions', // Watch for changes in modules
        availableOptions: 'updateModuleOptions', // Watch for changes in availableOptions
    },
    mounted() {
        this.getPermissions();
        this.updateModuleOptions();
        this.lang = lang;
        this.dom_array = this.domArrayVariable;
        this.getUserRole();
    },
    methods: {
        updateModuleOptions() {
            // this.moduleOptions = this.modules.map(() => this.availableOptions.map(() => ''));
        },
        getUserRole() {
            const self = this;
            self.record = self.$route.params.id;
            if (typeof (self.record) != 'undefined') {
                self.showpassfiled = false;
                 window.currentAction = 'list';
                axios.get('api/modules/user-roles/' + self.$route.params.id).then(function (response) {
                    self.userRole = response.data;
                    //self.userRole.status = self.userRole.status == 'Active' ? 1 : 0;
                    self.loading = false;
                }).catch(function () {
                    self.loading = false;
                });
            }
        },
        saveUserRole() {
            const errorMessages = document.getElementsByClassName('error-message');
            while (errorMessages.length > 0) {
                errorMessages[0].remove();
            }
            const self = this;

            self.loading = true;

            axios.put(`api/modules/user-roles/${self.$route.params.id}`, { module_data: self.action_data, name: self.userRole.name, status: self.userRole.status, id: self.userRole.id }).then(function (response) {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data update correctly').toString(),
                    type: 'success'
                });
                self.$router.push('/modules/user-roles');
            }).catch(function () {
                self.loading = false;
                let err = localStorage.getItem('Errors');
                let err_msg = (JSON.parse(err));
                let err_msg2 = err_msg.errors;
                Object.keys(err_msg2).forEach((key) => {
                    let errorval = err_msg2[key];
                    const input = document.getElementById(key);
                    const errorDiv = document.createElement('span');
                    errorDiv.className = 'error-message error';
                    errorDiv.textContent = errorval;
                    input.insertAdjacentHTML('afterend', errorDiv.outerHTML);
                });
                localStorage.removeItem('Errors');
            });
        },
        getPermissions() {
            const self = this;
            self.loading = true;
             window.currentAction = 'list';
                axios.get('api/modules/user-roles/permissions', { params: { 'parent_id': self.$route.params.id } }).then(function (response) {

                self.modules = response.data.modules;
                self.action_data = response.data.permission;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        },
    }

}